import type { Ref } from 'vue';
import api from '@sub/api/api';
import type { IService, ITimeslot } from '@types';
import { Disabled } from '@sub/components/calendar/core/Disabled';
import { getServiceBreak } from '@sub/utils/CuePriceLib2/service';

export function useOrderedTimeSlots(serviceId: Ref<number>) {
  const controller = new AbortController();
  const signal = controller.signal;

  function fetchOrderedTimeSlots() {
    if (!serviceId.value) return;
    return api.slots.all({
      serviceIds: [serviceId.value],
      dateTimeStart: getSlotsStartDate().toISOString(),
      limit: 500,
      returnService: false,
      returnOrder: false
    }, signal);
  }

  const { status, execute, data: orderedTimeSlots } = useAsyncData(fetchOrderedTimeSlots, {
    default: () => [],
  });

  watch(serviceId, () => execute());

  return {
    pendingSlots: computed(() => status.value === 'pending'),
    orderedTimeSlots,
  };
}

export function getDisabledFromOrderedSlots(slots: ITimeslot[], service: IService): Disabled[] {
  const mainOffset = getServiceBreak(service);
  return slots.map(({ start, end, availableSpots }) => new Disabled({
    availability: {
      total: availableSpots,
    },
    from: subMinutes(start, mainOffset),
    to: addMinutes(end, mainOffset),
  }));
}